import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { IconButton, Typography } from 'seagull';
import { ThumbDown, ThumbUp } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './FeedbackPromptBar.module.scss';
export const GetFeedbackPromptBarTID = (parentTestId)=>getTestIds(parentTestId);
export const FeedbackPromptBar = (param)=>{
    let { prompt, onSubmit, testId } = param;
    const [submitted, setSubmitted] = useState(false);
    const { FeedbackPromptBarTID } = useMemo(()=>GetFeedbackPromptBarTID(testId), [
        testId
    ]);
    const submitRating = (rating)=>{
        if (submitted) return;
        setSubmitted(true);
        onSubmit(rating);
    };
    if (submitted) return null;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": FeedbackPromptBarTID.Root(),
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: FeedbackPromptBarTID.Text(),
                children: prompt.text
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: 'agent_feedback_thumbs_up'
                },
                skin: "transparent",
                noPadding: true,
                size: "small",
                testId: FeedbackPromptBarTID.ThumbsUp(),
                onClick: ()=>submitRating('thumbsUp'),
                "aria-label": "Thumbs up",
                children: /*#__PURE__*/ _jsx(ThumbUp, {
                    size: 20
                })
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: 'agent_feedback_thumbs_down'
                },
                skin: "transparent",
                noPadding: true,
                size: "small",
                testId: FeedbackPromptBarTID.ThumbsDown(),
                onClick: ()=>submitRating('thumbsDown'),
                "aria-label": "Thumbs down",
                children: /*#__PURE__*/ _jsx(ThumbDown, {
                    size: 20
                })
            })
        ]
    });
};
